import { BreadCrumb } from 'primereact/breadcrumb';
import { Badge } from 'primereact/badge';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import HDIcon from '../icons/hd-icon.jsx';
import CCIcon from '../icons/cc-icon.jsx';
import FullScreenIcon from '../icons/full-screen-icon.jsx';
import { useEffect, useState } from 'react';
import { getTrainerDetail } from '../services/trainersService.js';
import TrainerCourseContent from './TrainerCourseContent.jsx';
import TrainerRating from './TrainerRating.jsx';
import CourseDiscussion from './CourseDiscussion.jsx';

const TrainerCourseDetail = ({ props }) => {
  const home = { label: 'Home', url: '/' };
  const {
    trainerData,
    trainerText,
    trainerIntroduce,
    trainerId,
    trainerContentProps,
  } = props;
  const [trainer, setTrainer] = useState();
  const [itemsBreadcrumb, setItemsBreadcrumb] = useState(() => {
    return [{ label: 'Trainer', url: '/trainers' }];
  });

  useEffect(() => {
    const getTrainer = async (id) => {
      const response = await getTrainerDetail(id);
      const data = response.data;
      setTrainer(data);
      setItemsBreadcrumb((prev) => [...prev, { label: response.data.name }]);
    };

    getTrainer(trainerId);
  }, []);

  const trainerDetailTabs = [
    {
      title: trainerIntroduce.introduceTitle,
      body: (
        <Introduce
          trainerIntroduce={trainerIntroduce}
          data={{
            timetable: trainer?.trainerIntroduce.schedule ?? [],
            introduceContent: trainer?.trainerIntroduce.introduce ?? '',
            targetContent: trainer?.trainerIntroduce.target ?? '',
            experienceContent: trainer?.trainerIntroduce.experience ?? '',
            educationContent: trainer?.trainerIntroduce.education ?? '',
          }}
        />
      ),
    },
    {
      title: 'Content',
      body: 'abc',
    },
    {
      title: 'FaQ',
      body: (
        <CourseDiscussion />
      ),
    },
    {
      title: 'Evaluate',
      body: (
        <TrainerRating
          props={{
            totalRating: trainerData.totalReview,
            trainerId: trainerData.id
          }}
          onRatingSuccess={(updatedTotalRating, updatedAverageRating) => {
            if (updatedTotalRating && trainer) {
              setTrainer(prev => ({
                ...prev,
                totalReview: updatedTotalRating,
                rate: updatedAverageRating || prev.rate,
              }));
            }
          }}
        />
      ),
    },
  ];

  return (
    <div className="grid px-2 md:px-4 lg:px-8 py-4">
      <div className="col-12 lg:col-8">
        <div className="flex flex-column gap-4">
          <BreadCrumb
            model={itemsBreadcrumb}
            home={home}
            className="p-0 border-none"
          />
          <InstructorProfile
            trainerData={{
              name: trainer?.name ?? '',
              trainerAvatar: trainerData.trainerAvatar,
              rate: trainer?.rate ?? '',
              totalReview: trainer?.totalReview ?? '',
              totalStudent: trainer?.totalCourse ?? '',
              totalCourse: trainer?.totalCourse ?? '',
            }}
            text={trainerText}
          />
          <TabView className="trainer-detail-tabs" scrollable>
            {trainerDetailTabs.map((item) => {
              return (
                <TabPanel
                  header={item.title}
                  className="w-full"
                  key={item.title}
                >
                  {item.body}
                </TabPanel>
              );
            })}
          </TabView>
        </div>
      </div>
      <div className="col-12 lg:col-4">
        <TrainerCourseContent
          props={trainerContentProps}
          coursePackagesData={trainer?.coursePackages ?? []}
        />
      </div>
    </div>
  );
};

const InstructorProfile = ({ trainerData, text }) => {
  const funFactInstuctor = [
    {
      label: (
        <span>
          {trainerData.rate}{' '}
          <span className="text-gray-600">
            ({numberWithCommas(trainerData.totalReview)} {text.review})
          </span>
        </span>
      ),
      icon: <i className="pi pi-star-fill" style={{ color: '#F97316' }}></i>,
    },
    {
      label: (
        <span>
          {trainerData.totalStudent}{' '}
          <span className="text-gray-600">{text.students}</span>
        </span>
      ),
      icon: <i className="pi pi-users" style={{ color: '#2563EB' }}></i>,
    },
    {
      label: (
        <span>
          {trainerData.totalCourse}{' '}
          <span className="text-gray-600">{text.courses}</span>
        </span>
      ),
      icon: <i className="pi pi-play-circle" style={{ color: '#F97316' }}></i>,
    },
  ];

  const instutorSocial = [
    {
      icon: <i className="pi pi-facebook"></i>,
      url: 'https://www.facebook.com',
    },
    {
      icon: <i className="pi pi-twitter"></i>,
      url: 'https://www.facebook.com',
    },
    {
      icon: <i className="pi pi-instagram"></i>,
      url: 'https://www.facebook.com',
    },
    {
      icon: <i className="pi pi-youtube"></i>,
      url: 'https://www.facebook.com',
    },
    {
      icon: <i className="pi pi-whatsapp"></i>,
      url: 'https://www.facebook.com',
    },
  ];
  return (
    <div className="border-1 border-blue-200 border-round-sm p-4 flex gap-4 flex-wrap lg:flex-nowrap">
      <img
        src={trainerData.trainerAvatar}
        className="border-circle w-9rem h-9rem"
      />
      <div className="flex flex-column gap-2">
        {/* Information */}
        <div className="flex flex-column gap-2">
          <div className="flex gap-2 align-items-center flex-wrap">
            <span className="text-2xl">{trainerData.name}</span>
            <Badge
              value={
                <span className="flex gap-1 align-items-center text-sm font-normal">
                  <i className="pi pi-crown"></i>
                  {text.topTrainer}
                </span>
              }
              className="border-noround px-3 py-2 h-auto"
              style={{ backgroundColor: '#F0FDF4', color: '#22C55E' }}
            ></Badge>
          </div>
          <span className="text-sm text-gray-600">{text.expertAt} KeduAll</span>
        </div>
        {/* Fun Fact about Instructor */}
        <div className="flex gap-4 align-items-center flex-wrap">
          {funFactInstuctor.map((item) => {
            return (
              <div
                key={item.label}
                className="flex gap-1 text-base align-items-center"
              >
                {item.icon}
                {item.label}
              </div>
            );
          })}
        </div>
        {/* Instructor socical*/}
        <div className="flex gap-2 align-items-center flex-wrap">
          {instutorSocial.map((item) => {
            return (
              <a
                key={item.label}
                className="p-3 bg-gray-50 text-gray-800"
                href={item.url}
              >
                {item.icon}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const Introduce = ({ trainerIntroduce, data }) => {
  const introduceList = [
    {
      title: trainerIntroduce.classSchedule,
      content: (
        <table className="w-full timetable p-0">
          <tr>
            <th className="fixed-col"></th>
            <th>CN</th>
            <th>T2</th>
            <th>T3</th>
            <th>T4</th>
            <th>T5</th>
            <th>T6</th>
            <th>T7</th>
          </tr>
          {data.timetable.map((slot, index) => (
            <tr>
              <td className="fixed-col flex flex-column align-items-center justify-content-center">
                <span className="m-0 font-size-14 font-weight-600">
                  {slot.period}
                </span>
                <span className="m-0 font-size-12 font-weight-600">{`(${slot.time})`}</span>
              </td>
              <td className={`${slot.sunday ? 'bg-primary' : 'bg-light'}`}></td>
              <td className={`${slot.monday ? 'bg-primary' : 'bg-light'}`}></td>
              <td
                className={`${slot.tuesday ? 'bg-primary' : 'bg-light'}`}
              ></td>
              <td
                className={`${slot.wednesday ? 'bg-primary' : 'bg-light'}`}
              ></td>
              <td
                className={`${slot.thursday ? 'bg-primary' : 'bg-light'}`}
              ></td>
              <td className={`${slot.friday ? 'bg-primary' : 'bg-light'}`}></td>
              <td
                className={`${slot.saturday ? 'bg-primary' : 'bg-light'}`}
              ></td>
            </tr>
          ))}
        </table>
      ),
    },
    {
      title: trainerIntroduce.introduceTitle,
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: data.introduceContent,
          }}
        ></div>
      ),
    },
    {
      title: trainerIntroduce.targetTitle,
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: data.targetContent,
          }}
        ></div>
      ),
    },
    {
      title: trainerIntroduce.experienceTitle,
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: data.experienceContent,
          }}
        ></div>
      ),
    },
    {
      title: trainerIntroduce.educationTitle,
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: data.educationContent,
          }}
        ></div>
      ),
    },
  ];
  return (
    <div className="flex flex-column gap-4">
      <div className="w-full h-auto relative inline-block">
        <img
          src={trainerIntroduce.trainerThumbnail}
          className="w-full max-h-full"
          alt="introduce"
        />
        <div
          className="absolute top-0 w-full h-full"
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0.20) 0%, #000 99.87%)',
          }}
        ></div>
        <div className="absolute top-0 w-full h-full flex flex-column justify-content-center align-items-center gap-3 p-1 md:p-5">
          <span className="text-lg md:text-2xl font-bold text-white text-center">
            {trainerIntroduce.videoTitle}
          </span>
          <span className="text-white text-xs md:text-sm text-center">
            {trainerIntroduce.videoSub}
          </span>
          <Button label={trainerIntroduce.buyNowBtn} size="small" />
        </div>
        <div className="absolute bottom-0 w-full flex justify-content-between align-items-center p-2">
          <div className="flex gap-2 align-items-center ">
            <Button
              label={trainerIntroduce.onlineBtn}
              size="small"
              className="text-xs p-1"
              style={{ gap: '0.125rem' }}
              icon="pi pi-play text-xs m-0"
            />
            <i className="pi pi-spin pi-volume-up text-white p-1"></i>
          </div>
          <div className="flex gap-1 align-items-center">
            <HDIcon />
            <CCIcon />
            <i className="pi pi-spin pi-cog text-white p-1"></i>
            <FullScreenIcon />
          </div>
        </div>
      </div>
      {introduceList.map((item) => {
        return (
          <div className="flex flex-column gap-3" key={item.title}>
            <span className="text-2xl font-semibold">{item.title}</span>
            {item.content}
          </div>
        );
      })}
    </div>
  );
};

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default TrainerCourseDetail;
